<mat-card>
    <mat-icon [svgIcon]="svgIcon">{{icon}}</mat-icon>
    <mat-card-actions>
        <button [color]="'primary'" mat-raised-button>
            <ng-content></ng-content>
        </button>
    </mat-card-actions>
</mat-card>
